var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70768 1.37516H9.16602C9.67018 1.37516 10.0827 1.78766 10.0827 2.29183V9.62516C10.0827 10.1293 9.67018 10.5418 9.16602 10.5418H1.83268C1.32852 10.5418 0.916016 10.1293 0.916016 9.62516V2.29183C0.916016 1.78766 1.32852 1.37516 1.83268 1.37516H2.29102V0.458496H3.20768V1.37516H7.79102V0.458496H8.70768V1.37516ZM1.83268 9.62516H9.16601V3.66683H1.83268V9.62516Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.92bca9ebd06e3d16011e57645ca3fcae.svg";
export { ForwardRef as ReactComponent };